import { Stack } from '@chakra-ui/react';
import Link from 'components/Link';
import { useUserContext } from 'context/UserContextProvider';
import useWorkshopUpdateRequestsQuery from 'hooks/useWorkshopUpdateRequestsQuery';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusTag } from '../../components/StatusTag';
import { DataTable } from '../../components/Table/DataTable';
import { dateTimeTransformer } from '../../helpers/dateTransformer';
import { ContentCard } from '../../layout/ContentCard';

const WorkshopDataUpdateRequestCard = ({ workshopId }: { workshopId: number }) => {
  const { t } = useTranslation();
  const { statusCodes } = useUserContext();

  const workshopUpdateRequestsQuery = useWorkshopUpdateRequestsQuery({
    workshop_id: workshopId,
  });

  const columns = useMemo(
    () => [
      {
        Header: t('forms:status.label'),
        accessor: 'status',
        // @ts-ignore
        Cell: ({ value }) => <StatusTag resourceKey={'workshop_update_request'} currentStatus={value} />,
      },
      {
        Header: t('forms:assignee.label'),
        accessor: 'assignee',
        // @ts-ignore
        Cell: ({ value }) => value?.name ?? '-',
        // @ts-ignore
      },
      {
        Header: t('forms:date.label'),
        accessor: (row: { processed_at: string }) => dateTimeTransformer(row.processed_at) ?? '-',
      },
      {
        id: 'button',
        accessor: 'id',
        // @ts-ignore
        Cell: (cellProps) => {
          const { row } = cellProps;
          return (
            <Link to={`/app/op/workshop-update-request/${row.original.id}`} data-test-id={'edit-' + row.index}>
              {t('common:details')}
            </Link>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [statusCodes?.workshop_update_request],
  );
  return (
    <ContentCard
      isLoading={workshopUpdateRequestsQuery.isLoading}
      minH="fit-content"
      header={t('sidebar:operations.data_change')}
      data-test-id="update-requests-overview-card"
    >
      <Stack direction={['column', 'row']} w={'100%'}>
        <Stack direction="column" w="full">
          <DataTable
            data-test-id="workshop-update-request-table"
            data={workshopUpdateRequestsQuery.data?.data || []}
            hasFilters={false}
            total={1}
            columns={columns}
            loading={workshopUpdateRequestsQuery.isFetching}
            isMoreThenOnePage={false}
            hasSearchInput={undefined as any}
          />
        </Stack>
      </Stack>
    </ContentCard>
  );
};

export default WorkshopDataUpdateRequestCard;
